import scroll from '@common/scroll/scroll'

import router     from '../router'
import { ERoute } from '../definitions'

import renderCategoryProducts from './utils/renderCategoryProducts';

(function IIFE (): void {
const hamburgerButton = document.body.querySelector<HTMLButtonElement>('#nav-hamburger-button')

if (hamburgerButton) {
  hamburgerButton.addEventListener('click', (e) => {
    e.preventDefault()

    // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/button#clicking_and_focus
    // https://bugs.webkit.org/show_bug.cgi?id=22261#c68
    hamburgerButton.focus()
  })
}

// Desktop search
const searchButton = document.body.querySelector<HTMLButtonElement>('#nav-search-button')

if (searchButton) {
  searchButton.addEventListener('click', async (e) => {
    e.preventDefault()

    const search = document.body.querySelector<HTMLInputElement>(
      '.nav__search-container.nav__search-container--desktop input.nav__search-input[name="search"]'
    )?.value ?? ''

    const categorySearchInput = document.body.querySelector<HTMLInputElement>(
      'input.categories-section__search-input'
    )

    if (categorySearchInput) {
      categorySearchInput.value = search
    }

    router.push(ERoute.Main)

    scroll.toId('category-products.categories-section__products-container')

    await renderCategoryProducts()
  })
}

// Mobile search
const mobileDetails = document.body.querySelector<HTMLDetailsElement>('.nav__mobile-search-container')

if (mobileDetails) {
  document.addEventListener('click', (e) => {
    if (mobileDetails.open && !e.composedPath().includes(mobileDetails)) {
      mobileDetails.open = false
    }
  })

  const button = mobileDetails.querySelector<HTMLButtonElement>('.nav__mobile-search-summary .nav__button')

  if (button) {
    button.addEventListener('click', (e) => {
      e.preventDefault()

      mobileDetails.open = !mobileDetails.open
    })
  }
}

const mobileSearchButton = document.body.querySelector<HTMLButtonElement>(
  '#nav-mobile-search-button'
)

if (mobileSearchButton) {
  mobileSearchButton.addEventListener('click', async (e) => {
    e.preventDefault()

    const search = document.body.querySelector<HTMLInputElement>(
      '.nav__search-container.nav__search-container--mobile input.nav__search-input[name="search"]'
    )?.value ?? ''

    const categorySearchInput = document.body.querySelector<HTMLInputElement>(
      'input.categories-section__search-input'
    )

    if (categorySearchInput) {
      categorySearchInput.value = search
    }

    router.push(ERoute.Main)

    scroll.toId('category-products.categories-section__products-container')

    await renderCategoryProducts()

    if (mobileDetails) {
      mobileDetails.open = false
    }
  })
}
})()
